import { useEffect, useRef } from "react";
import { Loader2, Send, X } from "lucide-react";
import { ProductStatus } from "@/components/ProductStatus";
import { useModalFocus } from "@/lib/useModalFocus";

export const OrderSendDialog = ({ email, orderEmail, busy, onEmailChange, onConfirm, onCancel, returnFocusRef }) => {
  const { dialogRef, onKeyDown } = useModalFocus(onCancel, busy, returnFocusRef);
  const emailRef = useRef(null);
  useEffect(() => { emailRef.current?.focus(); }, []);

  return (
    <div ref={dialogRef} onKeyDown={onKeyDown} tabIndex={-1}
         role="dialog" aria-modal="true" aria-labelledby="order-send-title"
         className="workflow-ux fixed inset-0 z-[60] flex items-center justify-center bg-black/40 p-4"
         data-testid="send-modal">
      <div className="bg-white w-full max-w-md border border-[#E5E5E0] shadow-xl">
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#F0F0EA]">
          <h3 id="order-send-title" className="font-serif text-lg">Invia ordine al fornitore</h3>
          <button type="button" onClick={onCancel} disabled={busy} aria-label="Chiudi invio ordine"
                  className="text-[#707070] hover:text-[#1A1A1A] disabled:opacity-50" data-testid="send-modal-close">
            <X className="w-4 h-4" aria-hidden="true" />
          </button>
        </div>
        <div className="p-6">
          <label htmlFor="send-modal-email" className="label-tiny">Email destinatario</label>
          <input ref={emailRef} id="send-modal-email" type="email" required className="input-luxury"
                 placeholder="fornitore@esempio.it" value={email} onChange={e=>onEmailChange(e.target.value)}
                 data-testid="send-modal-email" />
          <div className="flex flex-wrap items-center gap-2 mt-4 text-xs" data-testid="send-modal-order-email">
            <span>Le risposte arriveranno a</span>
            <ProductStatus tone="info" testId="send-modal-order-email-address">
              <span className="break-all">{orderEmail}</span>
            </ProductStatus>
          </div>
          <div className="mt-3 p-3 bg-[#FBF6EF] border-l-2 border-[#C5B39B] text-xs text-[#7A6A4A] leading-relaxed">
            Una volta inviato, l'ordine verrà <strong>bloccato</strong> e non sarà più modificabile.
          </div>
        </div>
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-[#F0F0EA]">
          <button type="button" onClick={onCancel} disabled={busy} className="btn-ghost text-sm" data-testid="send-modal-cancel">Annulla</button>
          <button type="button" onClick={onConfirm} disabled={busy} className="btn-primary text-sm inline-flex items-center gap-2"
                  data-testid="send-modal-confirm">
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" aria-hidden="true"/> : <Send className="w-3.5 h-3.5" aria-hidden="true"/>} Invia ordine
          </button>
        </div>
      </div>
    </div>
  );
};